export default __webpack_public_path__ + "static/media/BackArrow.c41989e3.svg";